<script lang="ts" context="module">
    // Safari bug that mismatches IDs
    let counter = 0
</script>

<script lang="ts">
    import { twMerge } from "tailwind-merge"

    export let spinning = false
    export let fading = false
    export let fadingSpeed = 5
    export let spinningSpeed = 3
    counter++
    export let purpleClassOuter = ""
    export let purpleClassInner = ""
    let className = ""
    export { className as class }
</script>

<svg
    version="1.1"
    id="circleofa-logo"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    style="filter: hue-rotate(31deg);enable-background:new 0 0 1000 1000;"
    xml:space="preserve"
    class={twMerge("will-change-transform transform-gpu", className)}
    {...$$restProps}
>
    <g id="proper_non_shaped">
        {#if fading}
            <animate
                attributeType="CSS"
                attributeName="opacity"
                values="0.3;0.8;0.3"
                dur={`${fadingSpeed}s`}
                repeatCount="indefinite"
            />
        {/if}
        <radialGradient
            id={"SVGID_1_" + counter}
            cx="500.4805"
            cy="499.8182"
            r="495.5195"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0.3447" style="stop-color:#467EC0" />
            <stop offset="1" style="stop-color:#467EC0;stop-opacity:0" />
        </radialGradient>
        <circle
            style={`fill:url(#SVGID_1_${counter});enable-background:new`}
            class={purpleClassOuter}
            cx="500.48"
            cy="499.82"
            r="495.52"
        />

        <circle
            style="stroke:#FFFFFF;fill:#fff0;stroke-width:5.3586;stroke-miterlimit:10;"
            cx="500.63"
            cy="503.88"
            r="169.52"
        />
        <circle
            class={purpleClassInner}
            style="fill:#467EC0;enable-background:new    ;"
            cx="500.63"
            cy="503.88"
            r="169.52"
        />

        <polygon
            style="fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;"
            points="
    500.47,632.61 488.01,506.2 459.05,524.11 476.79,494.98 407.55,483.41 479.01,471.58 462.48,442.96 488.87,458.39 500.01,391.89 
    511.66,459.5 543.54,439.53 523.83,471.41 592.73,483.15 525.24,494.5 543.6,524.14 512.41,504.79 	"
        />

        <radialGradient
            id={"logo-gradient-" + counter}
            cx="500.6324"
            cy="503.8763"
            r="169.5202"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#FFFFFF;stop-opacity:0" />
        </radialGradient>

        <circle
            style={`fill:url(#logo-gradient-${counter});stroke:#FFFFFF;stroke-miterlimit:10;`}
            cx="500.63"
            cy="503.88"
            r="169.52"
        />
        <g id="swirls">
            {#if spinning}
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    from="0 501 504"
                    to="360 501 504"
                    dur={`${spinningSpeed}s`}
                    repeatCount="indefinite"
                />
            {/if}
            <g id="scaler">
                <path
                    style="fill:#FFFFFF;"
                    d="M200.51,588.1c-12.48-57.46-3.75-118.16,17.9-172.4c36.03-91.64,115.8-167.55,214.15-185.94
                                c97.31-19.56,207.06,10.92,269.94,90.44c44.8,55.05,61.68,130.49,46.5,199.66c-20.66,101.17-108.13,180.19-210.31,192.8
                                c-73.47,10.16-144.99-13.7-190.38-73.91c-77.87-100.95-34.25-253.51,87.04-294.89c18.53-6.36,37.98-9.83,57.52-10.69
                                c0,0,0.1,2.48,0.1,2.48c-19.31,0.69-38.56,4.2-56.74,10.73c-115.44,40.22-154.17,189.8-74.92,281.99
                                c49.78,59.22,128.81,76.52,202.04,58.03c102.76-25.57,175.67-120.1,172.73-226.25c-5.19-165.23-171.92-254.55-322.45-215.15
                                c-86.86,22.22-156.13,91.14-190.26,172.75C200.84,471.05,190.68,530.69,200.51,588.1L200.51,588.1z"
                />
                <path
                    style="fill:#FFFFFF;"
                    d="M802.77,424.47c11.68,57.63,2.12,118.2-20.28,172.13c-37.3,91.14-118.11,165.93-216.7,182.97
                                c-97.57,18.21-206.89-13.78-268.66-94.16c-44.04-55.67-59.87-131.33-43.74-200.29c22.06-100.88,110.61-178.68,212.96-189.87
                                c73.6-9.15,144.79,15.7,189.34,76.53c76.47,102.02,30.75,253.96-91.11,293.66c-18.62,6.11-38.12,9.3-57.66,9.9
                                c0,0-0.06-2.49-0.06-2.49c19.32-0.42,38.61-3.67,56.88-9.94c115.98-38.62,156.78-187.65,78.81-280.93
                                c-48.96-59.91-127.74-78.29-201.22-60.82C338.21,345.31,264,438.82,265.47,545c2.91,165.28,168.39,256.9,319.45,219.58
                                c87.16-21.02,157.37-88.97,192.63-170.1C800.81,541.52,811.8,482.02,802.77,424.47L802.77,424.47z"
                />
            </g>
        </g>
    </g>
</svg>
